module.exports = __webpack_public_path__ + "img/f8.6e32ca23.png";